module.exports = require('./dist/segment/segment.js');
